import React, { useState } from 'react';
import { OktaAuth } from '@okta/okta-auth-js';
import { Security, LoginCallback } from '@okta/okta-react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginWidget from './components/LoginWidget';
import Home from './components/Home';
import Profile from './components/Profile';
import SecureRoute from './components/SecureRoute';
import { AppOktaProvider } from './auth/AppOktaContext';
import { IdpType, AppOIDCConfig } from './auth/types';

// Initialize Okta Auth
const oktaAuth = new OktaAuth({
  issuer: import.meta.env.VITE_OKTA_ISSUER || 'https://experian-nabgdc.okta.com/oauth2/aus8d3bt9unIW4yY72p7',
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID || '0oa198n3dzqR5dNfd2p8',
  redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI || 'http://localhost:4033/login/callback',
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
});

const App: React.FC = () => {
  const [oktaTenant, setOktaTenant] = useState<IdpType>(IdpType.OktaB2E);

  // Mock OIDC config - replace with your actual configuration
  const mockOIDCConfig: AppOIDCConfig = {
    b2bOidc: {
      issuer: import.meta.env.VITE_OKTA_ISSUER || 'https://experian-nabgdc.okta.com/oauth2/aus8d3bt9unIW4yY72p7',
      clientId: import.meta.env.VITE_OKTA_CLIENT_ID || '0oa198n3dzqR5dNfd2p8',
      redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI || 'http://localhost:4033/login/callback',
      scopes: ['openid', 'profile', 'email'],
      pkce: true,
    },
    b2eOidc: {
      issuer: import.meta.env.VITE_OKTA_ISSUER || 'https://experian-nabgdc.okta.com/oauth2/aus8d3bt9unIW4yY72p7',
      clientId: import.meta.env.VITE_OKTA_CLIENT_ID || '0oa198n3dzqR5dNfd2p8',
      redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI || 'http://localhost:4033/login/callback',
      scopes: ['openid', 'profile', 'email'],
      pkce: true,
    },
  };

  const customAuthHandler = () => {
    window.location.href = '/login';
  };

  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string) => {
    window.location.replace(originalUri || '/');
  };

  return (
    <AppOktaProvider
      value={{
        setOktaTenant,
        oktaTenant,
        oktaAuthService: oktaAuth,
        ascendSsarOIDCConfig: mockOIDCConfig,
      }}
    >
      <Router>
        <Security oktaAuth={oktaAuth} onAuthRequired={customAuthHandler} restoreOriginalUri={restoreOriginalUri}>
          <div className="app">
            <header style={{ 
              padding: '20px', 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              marginBottom: '20px',
              boxShadow: '0 4px 20px rgba(102, 126, 234, 0.3)'
            }}>
              <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                <h1 style={{ margin: 0, fontSize: '24px' }}>📱 Mobile Pre-Screen Demo</h1>
                <p style={{ margin: '5px 0 0 0', opacity: 0.9 }}>
                  Streamlined Application Processing with Secure Authentication
                </p>
              </div>
            </header>
            
            <main style={{ padding: '0 20px', maxWidth: '1200px', margin: '0 auto' }}>
              <Routes>
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route path="/login" element={<LoginWidget />} />
                <Route path="/login/callback" element={<LoginCallback />} />
                <Route 
                  path="/home" 
                  element={
                    <SecureRoute>
                      <Home />
                    </SecureRoute>
                  } 
                />
                <Route path="/login/callback" element={<LoginCallback />} />
                <Route 
                  path="/home" 
                  element={
                    <SecureRoute>
                      <Home />
                    </SecureRoute>
                  } 
                />
                <Route 
                  path="/profile" 
                  element={
                    <SecureRoute>
                      <Profile />
                    </SecureRoute>
                  } 
                />
              </Routes>
            </main>

            <footer style={{ 
              marginTop: '50px',
              padding: '20px', 
              background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
              color: '#2d3748',
              textAlign: 'center' as const,
              borderTop: '1px solid rgba(255, 255, 255, 0.2)'
            }}>
              <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>
                📱 Mobile Pre-Screen Demo Application - Streamlining Your Application Process
              </p>
            </footer>
          </div>
        </Security>
      </Router>
    </AppOktaProvider>
  );
};

export default App;